export type UserStatus = 'active' | 'pending' | 'inactive'
export type UserRole = 'admin' | 'member' | 'annotator'

/**
 * True for the P&ID annotation-only role: read-only across the app except the
 * P&ID editor. Kept as a helper so gating reads the same everywhere.
 */
export const isAnnotatorRole = (role?: string | null): boolean => role === 'annotator'

export interface OrganizationUser {
  user_id: string | null
  invite_id?: string | null
  email: string | null  
  name: string | null
  picture: string | null
  role: UserRole
  status: UserStatus
  joined_at: string | null
  id?: string
  added_on?: string | null
}

export interface OrganizationUsersResponse {
  organization_name: string
  users: OrganizationUser[]
}

export interface InviteUserRequest {
  email: string
  name?: string
  role: UserRole
}

export interface InviteUserResponse {
  invite_id: string
}

export interface UpdateUserRequest {
  role: UserRole
}

export interface UpdateUserResponse {
  user_id: string
  role: UserRole
  message: string
}

export const formatUserRole = (role: UserRole): string => {
  switch (role) {
    case 'admin':
      return 'Admin'
    case 'annotator':
      return 'Annotator'
    case 'member':
      return 'Member'
    default:
      return 'Member'
  }
}